import { type IWizardStep } from "../../../../../interfaces";
import { type FC, useEffect } from "react";
import { Typography } from "../../../../../components/common/Typography/Typography";
import { type DetailsState } from "../../state/slices/DetailsSlice";

import styles from "./packageDetails.module.scss";

export interface PackageDetailsProps extends IWizardStep {
  item: DetailsState["item"];
}

export const PackageDetails: FC<PackageDetailsProps> = ({ acceptHandlers, item }) => {
  useEffect(() => {
    acceptHandlers?.({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const contentItems = item.packageDetails?.contentItems ?? [];
  const additionalInfo = item.packageDetails?.additionalInfo;
  const hasAdditionalInfo = Boolean(additionalInfo?.author);

  const noInfoBlock = (
    <Typography variant="caption" color="grey" italic>
      No information available
    </Typography>
  );
  return (
    <div className={styles.root}>
      <div className={styles.section}>
        <Typography variant="title2" bold>
          Course Title
        </Typography>
        <Typography variant="paragraph">{item.title}</Typography>
      </div>

      <div className={styles.section}>
        <Typography variant="title2" bold>
          Modules
        </Typography>
        <ul className={styles.list}>
          {contentItems.map((contentItem) => (
            <li key={contentItem.launchPath || contentItem.title}>
              <Typography variant="paragraph">{contentItem.title}</Typography>
            </li>
          ))}
        </ul>
        {contentItems.length === 0 && noInfoBlock}
      </div>

      <div className={styles.section}>
        <Typography variant="title2" bold>
          Additional Info
        </Typography>
        {hasAdditionalInfo && (
          <ul className={styles.list}>
            <li>
              <Typography variant="paragraph">Author : {additionalInfo?.author}</Typography>
            </li>
            <li>
              <Typography variant="paragraph">Language : {additionalInfo?.language}</Typography>
            </li>
            <li>
              <Typography variant="paragraph">Version : {additionalInfo?.contentVersion}</Typography>
            </li>
          </ul>
        )}
        {!hasAdditionalInfo && noInfoBlock}
      </div>
    </div>
  );
};

export default PackageDetails;
